const imageTextThumbSliderModules = document.querySelectorAll('.image-text-thumb-slider');

const imageTextThumbSliderOptions = {
  slidesPerView: 2,
  spaceBetween: 4,
  watchOverflow: true,
  breakpoints: {
    520: {
      slidesPerView: 3,
    },
  },
};

const imageTextMainSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 600,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  thumbs: {
    swiper: false,
  },
};

imageTextThumbSliderModules.forEach((element) => {
  const imageTextMainSlider = element.querySelector('[data-slider="image-text-main-slider"]');
  const imageTextThumbSlider = element.querySelector('[data-slider="image-text-pagination-slider"]');

  new Swiper(imageTextThumbSlider, imageTextThumbSliderOptions);

  imageTextMainSliderOptions.thumbs.swiper = imageTextThumbSlider.swiper;
  new Swiper(imageTextMainSlider, imageTextMainSliderOptions);
});

// **********************************************************
// Image Text Thumb Animations
// **********************************************************

const imageTextThumbSliderImages = document.querySelectorAll('.image-text-thumb-slider__image img');

imageTextThumbSliderImages.forEach((image) => {
  const parentElem = image.closest('.image-text-thumb-slider__image-inner');
  gsap.to(image, {
    y: '20%',
    ease: 'none',
    scrollTrigger: {
      trigger: parentElem,
      start: 'top 80%',
      end: 'bottom top',
      scrub: true,
    },
  });
});
